'use client';
import { SelectedMenus, Template } from '@zeus/shared';
import { memo, useMemo } from 'react';
import Category from '../category';
import { isBetweenRange } from '../../../../../utils/utils';

interface MenuProps {
  menu: SelectedMenus;
  template: Template;
  development?: boolean;
  menuIndex: number;
  timezone?: string;
  scale?: number;
  tenantId?: number;
  column2FirstChild: string | null;
}

const Menu = ({
  menu,
  template,
  development,
  menuIndex,
  timezone,
  scale = 1,
  tenantId,
  column2FirstChild,
}: MenuProps) => {
  const categories = useMemo(() => menu.categories, [menu.categories]);
  const isDevelopment = development ? true : isBetweenRange(menu.schedules, timezone);

  return (
    <>
      {isDevelopment &&
        categories?.map((category, categoryIndex) => (
          <Category
            key={`category-${category.id}`}
            category={category}
            categoryIndex={categoryIndex}
            template={template}
            menuIndex={menuIndex}
            development={development}
            timezone={timezone}
            scale={scale}
            tenantId={tenantId}
            column2FirstChild={column2FirstChild}
          />
        ))}
    </>
  );
};

export default memo(Menu);
